import { css } from "@emotion/react";
import { ChevronDownIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useThemeState } from "@/hooks/useThemeState";
import { type Catalog, useCatalogState } from "../hooks/useCatalogState";
import { useCheckoutFormState } from "../hooks/useCheckoutFormState";
import { useInventoryState } from "../hooks/useInventoryState";
import { useStorefrontSettingsState } from "../hooks/useStorefrontSettingsState";
import type { ImmutableObject } from "../lib/immutable";
import { Button } from "./ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export type CatalogMenuProps = {
	css?: string;
};
export const CatalogMenu: React.FC<CatalogMenuProps> = (props) => {
	const themeState = useThemeState();
	const catalogState = useCatalogState();
	const checkoutFormState = useCheckoutFormState();
	const storefrontSettingsState = useStorefrontSettingsState();
	const isUniversity =
		storefrontSettingsState.get().settings?.IsUniversity ?? false;
	const filterCatalogsByLocation =
		storefrontSettingsState.get().settings?.FilterCatalogsByLocation ?? false;
	let catalogs = catalogState.get().catalogs || [];
	if (filterCatalogsByLocation && !isUniversity) {
		catalogs = catalogs.filter(
			(c) => c.WarehouseId === checkoutFormState.getWarehouse()?.WarehouseId,
		);
	}

	const inventoryState = useInventoryState();
	const navigate = useNavigate();

	const handleSelect = async (catalog?: Catalog | ImmutableObject<Catalog>) => {
		if (catalog) {
			checkoutFormState.selectCatalogLocation(catalog);
			navigate(`/inventory/${catalog.Id}`);
		}
	};

	return (
		<div
			css={css`
			display: flex;
			align-items: center;`}
		>
			<span
				css={css`padding:0 0.1rem 0 0;color:${themeState.isDark() ? "#ccc" : "#777"};`}
			></span>
			<DropdownMenu>
				<DropdownMenuTrigger
					render={
						<Button
							variant="link"
							size="xs"
							css={css`
					margin: 0 0 0 .5em;
					font-size:.8rem;
					display:flex;
					align-items: center;
					cursor: pointer;
					text-decoration: underline;
					text-underline-offset: 2px;
					${props.css ?? ""};`}
						>
							{inventoryState.get().catalog?.Name}
							<ChevronDownIcon size={14} />
						</Button>
					}
				/>
				<DropdownMenuContent align="end" className="w-auto min-w-40">
					{catalogs?.map((catalog) => (
						<DropdownMenuItem
							key={catalog.Id}
							onClick={async () => await handleSelect(catalog)}
						>
							{catalog.Name}
						</DropdownMenuItem>
					))}
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	);
};
